// Arquivo de mascáras JS
export function formatNumber(value) {
    return value.replace(/\D/g, "");
}

export function formatDate(value) {
    value = value.replace(/\D/g, "");

    if (value.length > 8) value = value.substring(0, 8);
    if (value.length > 2) value = value.substring(0, 2) + "/" + value.substring(2);
    if (value.length > 5) value = value.substring(0, 5) + "/" + value.substring(5);

    const parts = value.split("/");
    if (parts.length === 3) {
        let day = parseInt(parts[0], 10);
        let month = parseInt(parts[1], 10);
        let year = parts[2].length === 4 ? parseInt(parts[2], 10) : null;

        if (month < 1) month = 1;
        if (month > 12) month = 12;

        const daysInMonth = new Date(year || 2000, month, 0).getDate(); // Default year to 2000 if not provided
        if (day < 1) day = 1;
        if (day > daysInMonth) day = daysInMonth;

        if (year !== null && year < 1900) year = 1900; // Ensure year is at least 1900 if fully provided

        parts[0] = day.toString().padStart(2, "0");
        parts[1] = month.toString().padStart(2, "0");
        if (year !== null) parts[2] = year.toString();
        value = parts.join("/");
    }

    return value;
}

export function formatCpf(value) {
    value = value.replace(/[^\d]/g, ""); // Ignora caracteres além de números
    value = value.substring(0, 11);
    value = value.replace(/(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2})/, (match, p1, p2, p3, p4) => {
        let formatted = p1;
        if (p2) formatted += "." + p2;
        if (p3) formatted += "." + p3;
        if (p4) formatted += "-" + p4;
        return formatted;
    });

    return value;
}

export function formatCnpj(value) {
    value = value.replace(/[^\d]/g, "");
    value = value.substring(0, 14);
    value = value.replace(/(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,2})/, (match, p1, p2, p3, p4, p5) => {
        let formatted = p1;
        if (p2) formatted += "." + p2;
        if (p3) formatted += "." + p3;
        if (p4) formatted += "/" + p4;
        if (p5) formatted += "-" + p5;
        return formatted;
    });

    return value;
}

export function formatPhone(value) {
    value = value.replace(/\D/g, "");
    value = value.substring(0, 11);
    value = value.replace(/(\d{0,2})(\d{0,5})(\d{0,4})/, (match, p1, p2, p3) => {
        let formatted = "";
        if (p1) formatted += "(" + p1;
        if (p2) formatted += ") " + p2;
        if (p3) formatted += "-" + p3;
        return formatted;
    });

    return value;
}

export function formatZipcode(value) {
    value = value.replace(/\D/g, "");
    value = value.substring(0, 8);
    value = value.replace(/(\d{0,5})(\d{0,3})/, (match, p1, p2) => {
        let formatted = p1;
        if (p2) formatted += "-" + p2;
        return formatted;
    });

    return value;
}

export function formatSecurityCode(value) {
    value = value.replace(/\D/g, "");
    value = value.substring(0, 3);

    return value;
}

export function formatCardNumber(value) {
    value = value.replace(/\D/g, "");
    value = value.substring(0, 16);

    if (value.length <= 16) {
        value = value.replace(/(\d{4})(\d{4})(\d{4})(\d{4})/, "$1 $2 $3 $4");
    }

    return value;
}